import { render } from "./CreationPage.vue?vue&type=template&id=76f47df6"
import script from "./CreationPage.vue?vue&type=script&lang=js"
export * from "./CreationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__